if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        const selectedElements = [
          ...Array.from(this.querySelectorAll('select')).map((select) => select.selectedOptions[0]),
          ...this.querySelectorAll('fieldset input:checked'),
        ].filter(Boolean);

        return selectedElements.map(({ dataset }) => dataset.optionValueId);
      }

      get variantData() {
        if (!this._variantData) {
          const variantDataElement = this.querySelector('[data-product-variants]');
          if (variantDataElement) {
            this._variantData = JSON.parse(variantDataElement.textContent);
            variantDataElement.remove();
          } else {
            this._variantData = [];
          }
        }

        return this._variantData;
      }

      getSelectedOptionValuesByName() {
        const normalize = (value) => (value || '').toString().trim();
        return Array.from(this.querySelectorAll('.product-form__input'))
          .map((group) => {
            const checkedInput = group.querySelector('input:checked');
            if (checkedInput) return normalize(checkedInput.value);

            const select = group.querySelector('select');
            if (select) return normalize(select.value);

            return null;
          })
          .filter((value) => value !== null);
      }

      getVariantFromSelectedOptions(selectedOptions) {
        if (!this.variantData.length || !selectedOptions.length) return null;

        const normalize = (value) => (value || '').toString().trim().toLowerCase();

        return this.variantData.find((variant) =>
          selectedOptions.every(
            (value, index) => normalize(variant[`option${index + 1}`]) === normalize(value)
          )
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          const selectedOptionNames = this.getSelectedOptionValuesByName();
          const matchedVariant = this.getVariantFromSelectedOptions(selectedOptionNames);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
              selectedOptionNames,
              variantId: matchedVariant?.id,
              variant: matchedVariant || null,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
